// @flow
import { Link } from 'react-router-dom'
import React, { lazy, Suspense } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import config from 'config'
import { LocaleContext } from '../../contexts/locale'
import germanMessages from './locales/de.yml'
import frenchMessages from './locales/fr.yml'

const ClubSearch = lazy(() => import('components/clubSearch'))

const MESSAGES = {
  de: germanMessages,
  fr: frenchMessages
}

/**
 * Club Selection content fragment.
 * @param match
 * @param handleClubSelection
 * @param [locale=de]
 * @returns {*}
 * @constructor
 */
export function ClubSelection({
  match,
  handleClubSelection,
  locale = 'de'
}: {
  match: any,
  handleClubSelection: number => void,
  locale: string
}) {
  const t = config.translationServiceFactory(MESSAGES, locale)

  return (
    <div className='step municipality-selection'>
        {/* <div className='ui text container'>
          <div className='ui icon message'>
            <div className='content'>
              <div className='header'><i className='icon comments'></i>Bis Ende August!</div>
              <p>Der Fussballroboter ist voraussichtlich am Wochenende vom 27. August wieder für Sie da. 
                <strong> Bis dahin: Mit nur fünf Minuten Ihrer Zeit</strong> können Sie uns dabei helfen, den Fussballroboter mit <a href="https://forms.gle/Y9FELiCZLG77Z77V9">dieser Umfrage</a> zu verbessern.</p>
            </div>
          </div>
        </div> */}
      {true && (<div className='ui text container'>
          <div className='ui icon message'>
            <div className='content'>
              <div className='header'><i className='icon file alternate'></i>Angebot wird pausiert</div>
              <p>Liebe Leserinnen und Leser. 
                Die Daten, die den automatisch geschriebenen Texten zu Grunde liegen, werden von der Website des Schweizerischen Fussballverbandes heruntergeladen. 
                Leider sind dabei in den letzten Monaten immer grössere Hürden aufgetreten, die es uns aktuell verunmöglichen, den Service weiterhin anzubieten. 
                Besten Dank für Ihre Treue!</p>
            </div>
          </div>
          </div>)}
      {/* <h3 className='ui header'>
        <div className='sub header'>{t('title')}</div>
        {t('subtitle')}
      </h3>

      <Suspense fallback={config.searchFallback}>
        <ClubSearch
          locale={locale}
          label={t('searchFieldLabel')}
          onSelectionHandler={handleClubSelection}
        />
      </Suspense>

      <div className='teams-link'>
        <Link to='/all-teams'>
          Zur Liste aller Teams <i className='ui icon chevron right' />
        </Link>
      </div> */}
    </div>
  )
}

const ClubSelectionWithContext = props => (
  <LocaleContext.Consumer>
    {locale => <ClubSelection locale={locale} {...props} />}
  </LocaleContext.Consumer>
)

export default ClubSelectionWithContext
